import { 
  Building2, 
  Users, 
  Package, 
  Database, 
  Settings, 
  FileText, 
  Check, 
  Percent 
} from 'lucide-react';

/**
 * Quote Wizard Step Configuration
 * Defines the steps in the quote creation process
 * 
 * @property {string} id - Unique identifier for the step
 * @property {string} name - Display name shown in UI
 * @property {Component} icon - Lucide icon component
 */
export const steps = [
  { id: 'deal', name: 'Deal Info', icon: Building2 },
  { id: 'platform', name: 'Platform', icon: Package },
  { id: 'users', name: 'Users', icon: Users },
  { id: 'products', name: 'Products', icon: Database },
  { id: 'services', name: 'Services', icon: Settings },
  { id: 'initial-review', name: 'Initial Review', icon: FileText },
  { id: 'discounts', name: 'Apply Discounts', icon: Percent },
  { id: 'terms', name: 'Terms & Conditions', icon: FileText },
  { id: 'final-review', name: 'Final Review', icon: Check }
];

/**
 * Step IDs for programmatic reference
 */
export const STEP_IDS = {
  DEAL_INFO: 0,
  PLATFORM: 1,
  USERS: 2,
  PRODUCTS: 3,
  SERVICES: 4,
  INITIAL_REVIEW: 5,
  DISCOUNTS: 6,
  TERMS: 7,
  FINAL_REVIEW: 8
};

/**
 * Get step by index
 * @param {number} index - Step index
 * @returns {Object} Step configuration
 */
export const getStep = (index) => steps[index];

/**
 * Get step name by index
 * @param {number} index - Step index
 * @returns {string} Step name
 */
export const getStepName = (index) => steps[index]?.name || '';

/**
 * Total number of steps
 */
export const TOTAL_STEPS = steps.length;

export default steps;
